import DOMPurify from "dompurify";
import { istHtml } from "./planungAnzeige";

/**
 * Beschreibung einer Aufgabe in der Detailansicht: HTML bereinigt (DOMPurify),
 * Klartext mit Zeilenumbrüchen und klickbaren Links.
 *
 * Eigene DOMPurify-Instanz, damit der Hook für `target`/`rel` nur hier greift und
 * nicht in den anderen Stellen der App, die DOMPurify benutzen.
 */
let purify: ReturnType<typeof DOMPurify> | null = null;

function reiniger() {
  if (purify) return purify;
  purify = DOMPurify(window);
  purify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
  return purify;
}

const ERLAUBTE_TAGS = [
  "p", "br", "strong", "b", "em", "i", "u", "s", "a", "ul", "ol", "li",
  "h1", "h2", "h3", "h4", "blockquote", "code", "pre", "span", "div", "hr",
];

function escape(text: string): string {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

/** Klartext → HTML: maskieren, Links klickbar, Zeilenumbrüche erhalten. */
function klartextZuHtml(text: string): string {
  return escape(text)
    .replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1">$1</a>')
    .replace(/\n/g, "<br>");
}

export function bereinigtesHtml(beschreibung: string): string {
  const roh = istHtml(beschreibung) ? beschreibung : klartextZuHtml(beschreibung);
  return reiniger().sanitize(roh, {
    ALLOWED_TAGS: ERLAUBTE_TAGS,
    ALLOWED_ATTR: ["href", "target", "rel"],
  });
}
